'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Textfield } from '../../components/input-with-validation';
import { DEFAULT_ERROR_MESSAGE } from '../b2b-funnel-embed.consts';
import addressStyles from './address.module.scss';
import sharedStyles from './shared-styles.module.scss';
export const AddressStep = ({ funnelState })=>{
    const streetError = funnelState?.errors?.address?.street;
    const houseNumberError = funnelState?.errors?.address?.houseNumber;
    const cityError = funnelState?.errors?.address?.city;
    const postalCodeError = funnelState?.errors?.address?.postalCode;
    const companyNameError = funnelState?.errors?.address?.companyName;
    return /*#__PURE__*/ _jsxs("div", {
        className: sharedStyles['funnel-step'],
        children: [
            /*#__PURE__*/ _jsx(Textfield, {
                className: sharedStyles['input-spacing'],
                defaultValue: funnelState.formValues.companyName,
                name: "companyName",
                placeholder: "Firmenname",
                statusLabel: companyNameError ?? ' ',
                statusType: companyNameError ? 'error' : 'default',
                messages: {
                    minLength: DEFAULT_ERROR_MESSAGE
                },
                minLength: 2,
                required: true
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: addressStyles['street-name-number-row'],
                children: [
                    /*#__PURE__*/ _jsx(Textfield, {
                        className: addressStyles.street,
                        defaultValue: funnelState.formValues.street,
                        name: "street",
                        placeholder: "Straßenname",
                        statusLabel: streetError ?? ' ',
                        statusType: streetError ? 'error' : 'default',
                        messages: {
                            minLength: DEFAULT_ERROR_MESSAGE
                        },
                        minLength: 2,
                        required: true
                    }),
                    /*#__PURE__*/ _jsx(Textfield, {
                        className: addressStyles['street-number'],
                        defaultValue: funnelState.formValues.houseNumber,
                        name: "houseNumber",
                        placeholder: "Nr.",
                        statusLabel: houseNumberError ?? ' ',
                        statusType: houseNumberError ? 'error' : 'default',
                        messages: {
                            minLength: DEFAULT_ERROR_MESSAGE
                        },
                        minLength: 1,
                        required: true
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: addressStyles['postal-code-city-row'],
                children: [
                    /*#__PURE__*/ _jsx(Textfield, {
                        className: addressStyles['postal-code'],
                        defaultValue: funnelState.formValues.postalCode,
                        name: "postalCode",
                        placeholder: "Postleitzahl",
                        statusLabel: postalCodeError,
                        statusType: postalCodeError ? 'error' : 'default',
                        messages: {
                            pattern: 'Es müssen genau 5 Ziffern sein'
                        },
                        pattern: "^\\d{5}$",
                        required: true
                    }),
                    /*#__PURE__*/ _jsx(Textfield, {
                        className: addressStyles.city,
                        defaultValue: funnelState.formValues.city,
                        name: "city",
                        placeholder: "Stadt",
                        statusLabel: cityError ?? ' ',
                        statusType: cityError ? 'error' : 'default',
                        messages: {
                            minLength: DEFAULT_ERROR_MESSAGE
                        },
                        minLength: 2,
                        required: true
                    })
                ]
            })
        ]
    });
};

//# sourceMappingURL=address.js.map